// Port of api/fuel/app/classes/insights/games/init.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import DB from 'offline/db'

function parseGamesIndex(row) {
	if (!row) return []
	var raw = row.insight_games
	if (!raw) return []
	try {
		var parsed = JSON.parse(raw)
		if (Array.isArray(parsed)) return parsed.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		if (parsed && Array.isArray(parsed.games)) return parsed.games.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
		if (parsed && Array.isArray(parsed.index)) return parsed.index.map(function(id) { return parseInt(id, 10) }).filter(Boolean)
	} catch (e) {
		// Fall through to legacy comma-separated parsing.
	}
	return String(raw).split(',').map(function(id) { return parseInt(id, 10) }).filter(Boolean)
}

export default Segment.extend({
	name: 'init',
	priority: 10,
	types: [Constants.TYPE_USER],
	run: function(type, owner) {
		var userId = owner.get_id()

		var snapshotRows = DB.query(
			'SELECT * FROM insight_user_games WHERE user_id = ' + userId + ' ORDER BY insight_date DESC LIMIT 1'
		)
		var snapshot = snapshotRows.length ? snapshotRows[0] : null
		var gameIndex = parseGamesIndex(snapshot)

		// Fallback when no snapshot exists offline yet.
		if (!gameIndex.length) {
			gameIndex = Util.queryFast(
				'SELECT id FROM (' +
				' SELECT c.game_id AS id FROM collection c JOIN game g ON g.game_id = c.game_id WHERE c.user_id = ' + userId + ' AND g.game_type = 1' +
				' UNION ' +
				' SELECT p.game_id AS id FROM play p JOIN game g ON g.game_id = p.game_id WHERE p.user_id = ' + userId + ' AND g.game_type = 1' +
				' UNION ' +
				' SELECT r.game_id AS id FROM rating r JOIN game g ON g.game_id = r.game_id WHERE r.user_id = ' + userId + ' AND g.game_type = 1' +
				') ORDER BY id'
			).map(function(row) { return parseInt(row.id, 10) })
		}

		this._data.game_index = gameIndex
		this._data.snapshot = snapshot

		if (!gameIndex.length) {
			this._data.first_touch = {}
			this._data.play_data = { firsts: {}, lasts: {}, counts: {} }
			this._data.rating_data = { firsts: {}, lasts: {}, values: {} }
			this._data.collection_data = {}
			return {}
		}

		var playFirsts = {}
		var lastPlays = {}
		var playCounts = {}

		var playRows = Util.queryFast(
			'SELECT p.game_id AS g, MIN(p.play_date) AS fp, MAX(p.play_date) AS lp, SUM(p.play_count) AS c' +
			' FROM play p JOIN game g ON g.game_id = p.game_id AND g.game_type = 1' +
			' WHERE p.user_id = ' + userId +
			' GROUP BY p.game_id'
		)

		for (var i = 0; i < playRows.length; i++) {
			playFirsts[parseInt(playRows[i].g, 10)] = parseInt(playRows[i].fp, 10)
			lastPlays[parseInt(playRows[i].g, 10)] = parseInt(playRows[i].lp, 10)
			playCounts[parseInt(playRows[i].g, 10)] = parseInt(playRows[i].c, 10)
		}

		this._data.play_data = {
			firsts: playFirsts,
			lasts: lastPlays,
			counts: playCounts
		}

		var ratingFirsts = {}
		var lastRatings = {}
		var ratingValues = {}

		var ratingRows = Util.queryFast(
			'SELECT r.game_id AS g, MIN(r.rating_date) AS fr, MAX(r.rating_date) AS lr, MAX(r.rating_value) AS v' +
			' FROM rating r JOIN game g ON g.game_id = r.game_id AND g.game_type = 1' +
			' WHERE r.user_id = ' + userId +
			' GROUP BY r.game_id'
		)

		for (var j = 0; j < ratingRows.length; j++) {
			ratingFirsts[parseInt(ratingRows[j].g, 10)] = parseInt(ratingRows[j].fr, 10)
			lastRatings[parseInt(ratingRows[j].g, 10)] = parseInt(ratingRows[j].lr, 10)
			ratingValues[parseInt(ratingRows[j].g, 10)] = parseFloat(ratingRows[j].v)
		}

		this._data.rating_data = {
			firsts: ratingFirsts,
			lasts: lastRatings,
			values: ratingValues
		}

		var collectionData = {}

		var collectionRows = Util.queryFast(
			'SELECT c.game_id AS g, MAX(c.collection_date_updated) AS d, MAX(c.collection_own) AS owned,' +
			' MAX(c.collection_prevowned) AS prevowned, MAX(c.collection_wishlist) AS wishlisted' +
			' FROM collection c WHERE c.user_id = ' + userId +
			' AND c.collection_expansion = 0 GROUP BY c.game_id'
		)

		for (var k = 0; k < collectionRows.length; k++) {
			collectionData[parseInt(collectionRows[k].g, 10)] = {
				date: parseInt(collectionRows[k].d, 10),
				owned: parseInt(collectionRows[k].owned, 10),
				prevowned: parseInt(collectionRows[k].prevowned, 10),
				wishlisted: parseInt(collectionRows[k].wishlisted, 10) > 0 ? 1 : 0
			}
		}

		var collectionFirsts = {}

		var collectionLogRows = Util.queryFast(
			'SELECT l.game_id AS g, MIN(l.log_date) AS d' +
			' FROM log_user_collection l JOIN game g ON g.game_id = l.game_id AND g.game_type = 1' +
			' WHERE l.user_id = ' + userId +
			' AND l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			' AND l.log_date > 0 GROUP BY l.game_id'
		)

		for (var cl = 0; cl < collectionLogRows.length; cl++) {
			collectionFirsts[parseInt(collectionLogRows[cl].g, 10)] = parseInt(collectionLogRows[cl].d, 10)
		}

		var collectionDateRows = Util.queryFast(
			'SELECT c.game_id AS g, MIN(CASE' +
			' WHEN c.collection_date_owned > 0 AND c.collection_date_acquired > 0 THEN MIN(c.collection_date_owned, c.collection_date_acquired)' +
			' WHEN c.collection_date_owned > 0 THEN c.collection_date_owned' +
			' WHEN c.collection_date_acquired > 0 THEN c.collection_date_acquired' +
			' ELSE 2147483647 END) AS d' +
			' FROM collection c WHERE c.user_id = ' + userId +
			' AND c.collection_expansion = 0 GROUP BY c.game_id'
		)

		for (var cd = 0; cd < collectionDateRows.length; cd++) {
			var gid = parseInt(collectionDateRows[cd].g, 10)
			var d = parseInt(collectionDateRows[cd].d, 10)
			if (d > 0 && d < 2147483647 && (!collectionFirsts[gid] || d < collectionFirsts[gid])) collectionFirsts[gid] = d
		}

		this._data.collection_data = collectionData

		var wishlistFirsts = {}
		var wishlistRows = Util.queryFast(
			'SELECT l.game_id AS g, MIN(l.log_date) AS d' +
			' FROM log_user_collection_status l JOIN game g ON g.game_id = l.game_id AND g.game_type = 1' +
			' WHERE l.user_id = ' + userId +
			' AND l.log_status = ' + Constants.COLLECTION_STATUS_WISHLIST +
			' AND l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			' GROUP BY l.game_id'
		)

		for (var wl = 0; wl < wishlistRows.length; wl++) {
			wishlistFirsts[parseInt(wishlistRows[wl].g, 10)] = parseInt(wishlistRows[wl].d, 10)
		}

		var firstTouch = {}

		for (var gi = 0; gi < gameIndex.length; gi++) {
			var gameId = parseInt(gameIndex[gi], 10)
			var earliest = null
			var source = null

			if (playFirsts[gameId] > 0) {
				earliest = playFirsts[gameId]
				source = 'Played'
			}
			if (ratingFirsts[gameId] > 0 && (earliest === null || ratingFirsts[gameId] < earliest)) {
				earliest = ratingFirsts[gameId]
				source = 'Rated'
			}
			if (collectionFirsts[gameId] > 0 && collectionFirsts[gameId] < 2147483647 && (earliest === null || collectionFirsts[gameId] < earliest)) {
				earliest = collectionFirsts[gameId]
				if (collectionData[gameId] && collectionData[gameId].owned) source = 'Own'
				else if (collectionData[gameId] && collectionData[gameId].prevowned) source = 'Previously Owned'
				else source = 'Own'
			}
			if (wishlistFirsts[gameId] > 0 && (earliest === null || wishlistFirsts[gameId] < earliest)) {
				earliest = wishlistFirsts[gameId]
				source = 'Wishlisted'
			}

			if (earliest !== null) {
				firstTouch[gameId] = {
					date: earliest,
					type: source
				}
			}
		}

		this._data.first_touch = firstTouch
		return {}
	}
})
